import React from 'react'
import './style.scss'

export function ContextLoader({ fixed = true }) {
    return (
        <div data-testid='context-loader-component' className={`context-loader-component ${fixed ? 'context-loader-component--fixed' : ''}`}>
            <img alt='Diferpan' src='https://cdn.diferpan.com.br/arquivos/publico/sgd/logo/Logo_Azul_e_Vermelho_sem_Fundo.png' className='loader-img' />
        </div>
    )
}
